export enum RefundStepEnum {
  None = 'None',
  ReturnCard = 'ReturnCard',
  InsertCard = 'InsertCard',
  Login = 'Login',
  Balance = 'Balance',
  Refund = 'Refund',
}
